import React, { useEffect, useState, PropsWithChildren } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { greyish } from '~/styles';

interface Props {
  onChange: (isVisible: boolean) => void;
}

export const PasswordVisibilityIcon: React.FC<PropsWithChildren<Props>> = ({ onChange }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  useEffect(() => {
    onChange(isPasswordVisible);
  }, [isPasswordVisible, onChange]);

  return !isPasswordVisible ? (
    <VisibilityIcon style={{ color: greyish }} onClick={() => setIsPasswordVisible(true)} />
  ) : (
    <VisibilityOffIcon style={{ color: greyish }} onClick={() => setIsPasswordVisible(false)} />
  );
};
